// Misma lista que arca-admin-api/src/constants/provincias.js — se usa como
// ST/L en el CSR de certificados del cliente (ver GenerateCsrWizard en
// ClientDetail.jsx). Duplicada a propósito, mismo criterio que el resto del
// código compartido entre los dos backends (ver CLAUDE.md).
export const PROVINCIAS = [
  'Capital Federal',
  'Buenos Aires',
  'Catamarca',
  'Chaco',
  'Chubut',
  'Córdoba',
  'Corrientes',
  'Entre Ríos',
  'Formosa',
  'Jujuy',
  'La Pampa',
  'La Rioja',
  'Mendoza',
  'Misiones',
  'Neuquén',
  'Río Negro',
  'Salta',
  'San Juan',
  'San Luis',
  'Santa Cruz',
  'Santa Fe',
  'Santiago del Estero',
  'Tierra del Fuego',
  'Tucumán',
];
